import axios from 'src/utils/axios';
import parse from 'src/utils/parse';
import logger from 'src/utils/logger';
import { SubOrgUserApiResponse } from 'src/types/mindtime/users';

class MindtimeUsersApi {
  async getSubOrgUsers(): Promise<SubOrgUserApiResponse[]> {
    return new Promise((resolve, reject) => {
      const baseUrl = process.env.REACT_APP_BSI;
      if (!baseUrl) {
        const error = new Error('REACT_APP_BSI environment variable is not defined');
        logger(error, 'error');
        reject(error);
        return;
      }

      axios
        .get(`${baseUrl}/ahsay-user/sub-org-users`)
        .then((response) => {
          const parsedResponse = parse(response);
          resolve((parsedResponse?.data || []) as SubOrgUserApiResponse[]);
        })
        .catch((error) => {
          logger(error, 'error');
          reject(error);
        });
    });
  }

  async getAll(orgId: string): Promise<any> {
    return new Promise((resolve, reject) => {
      axios
        .get(`${process.env.REACT_APP_BSI}/mindtime/users/${orgId}`)
        .then((response) => {
          response = parse(response);
          resolve(response?.data);
        })
        .catch((error) => {
          logger(error, 'error');
          reject(error);
        });
    });
  }

  async getById(orgId: string, userId: string): Promise<any> {
    return new Promise((resolve, reject) => {
      axios
        .get(`${process.env.REACT_APP_BSI}/mindtime/users/${orgId}/${userId}`)
        .then((response) => {
          response = parse(response);
          resolve(response?.data);
        })
        .catch((error) => {
          logger(error, 'error');
          reject(error);
        });
    });
  }

  async create(orgId: string, payload: any): Promise<any> {
    return new Promise((resolve, reject) => {
      axios
        .post(`${process.env.REACT_APP_BSI}/mindtime/users/${orgId}`, payload)
        .then((response) => {
          response = parse(response);
          resolve(response?.data);
        })
        .catch((error) => {
          logger(error, 'error');
          reject(error);
        });
    });
  }

  async update(orgId: string, userId: string, payload: any): Promise<any> {
    return new Promise((resolve, reject) => {
      axios
        .patch(`${process.env.REACT_APP_BSI}/mindtime/users/${orgId}/${userId}`, payload)
        .then((response) => {
          response = parse(response);
          resolve(response?.data);
        })
        .catch((error) => {
          logger(error, 'error');
          reject(error);
        });
    });
  }
}

export const mindtimeUsersApi = new MindtimeUsersApi();
